// extracted by mini-css-extract-plugin
module.exports = {"footer":"FutureNonWorkingDayDialogTooltip_footer__3iM2w"};